import React from 'react';
import ReactDOM from 'react-dom';
import OToast from './Toast';
import { addContainer, uid, removeElementClass } from '../_utils';
var setup = {
    options: {
        duration: 5000,
        variant: 'info',
        description: null,
        messageInfo: null,
        dismissable: true
    },
    containerId: 'toasts-collection-container',
    containerPadding: '2rem',
    containerZindex: 100000,
    containerItemClass: 'mt-2',
    componentList: []
};
var render = function () {
    return ReactDOM.render(React.createElement("div", { className: "position-fixed", style: {
            right: setup.containerPadding,
            bottom: setup.containerPadding,
            zIndex: setup.containerZindex
        } }, setup.componentList.map(function (item) { return (React.createElement("div", { key: item.id, className: setup.containerItemClass }, item.component)); })), document.getElementById(setup.containerId));
};
var hide = function (id) {
    removeElementClass(id, 'show');
    setTimeout(function () {
        setup.componentList = setup.componentList.filter(function (i) { return i.id !== id; });
        render();
    }, 100);
};
var show = function (message, options) {
    var id = uid('toast');
    var _a = (options || {}).duration, duration = _a === void 0 ? setup.options.duration : _a;
    var _b = (options || {}).messageInfo, messageInfo = _b === void 0 ? setup.options.messageInfo : _b;
    var _c = (options || {}).variant, variant = _c === void 0 ? setup.options.variant : _c;
    var _d = (options || {}).description, description = _d === void 0 ? setup.options.description : _d;
    var _e = (options || {}).dismissable, dismissable = _e === void 0 ? setup.options.dismissable : _e;
    addContainer(setup.containerId);
    render();
    setup.componentList.push({
        id: id,
        component: (React.createElement(OToast, { id: id, message: message, messageInfo: messageInfo, variant: variant, description: description, dismissable: dismissable, animated: true }))
    });
    render();
    window.setTimeout(function () { return hide(id); }, duration);
};
var showInfo = function (message, description, duration, dismissable) { return show(message, { description: description, duration: duration, dismissable: dismissable }); };
var showWarning = function (message, description, duration, dismissable) {
    return show(message, {
        variant: 'warning',
        description: description,
        duration: duration,
        dismissable: dismissable
    });
};
var showError = function (message, description, duration, dismissable) {
    return show(message, {
        variant: 'danger',
        description: description,
        duration: duration,
        dismissable: dismissable
    });
};
var showSuccess = function (message, description, duration, dismissable) {
    return show(message, {
        variant: 'success',
        description: description,
        duration: duration,
        dismissable: dismissable
    });
};
export { show as showToast, showInfo, showWarning, showError, showSuccess };
